import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

const APP_VERSION = "0.12";
(() => {
  let version = localStorage.getItem("_appVersion");
  if (!version || version != APP_VERSION) {
    localStorage.setItem("_appVersion", APP_VERSION);
    window.location.reload(true);
  }
})();

Vue.config.productionTip = false;

// simple storage

Vue.prototype.$storage = {
  _data: null,
  _lastStationId: 1,
  _userInfo: { name: "" },
  version: APP_VERSION,
  load() {
    let data = localStorage.getItem("_data");

    if (data) {
      this._data = JSON.parse(data);
    } else {
      this._data = {
        stations: []
      };
    }

    let lastStationId = localStorage.getItem("_lastStationId");
    if (lastStationId) {
      this._lastStationId = parseInt(lastStationId);
    }

    let userInfo = localStorage.getItem("_userInfo");
    if (userInfo) {
      this._userInfo = JSON.parse(userInfo);
    }
  },
  save() {
    localStorage.setItem("_data", JSON.stringify(this._data));
    localStorage.setItem("_lastStationId", this._lastStationId);
    localStorage.setItem("_userInfo", JSON.stringify(this._userInfo));
  },
  reset() {
    localStorage.removeItem("_data");
    localStorage.removeItem("_lastStationId");
    localStorage.removeItem("_userInfo");
    this.load();
  },
  getStations() {
    return this._data.stations;
  },
  getStationById(id) {
    return this._data.stations.find(e => e.id === id);
  },
  createStation(name, weight, reps) {
    const station = {
      id: this._lastStationId++,
      weight,
      reps,
      name
    };
    this._data.stations.push(station);
    this.save();
  },
  deleteStation(stationId) {
    console.log("deleteStation:", stationId);
    const stationIndex = this._data.stations.findIndex(e => e.id === stationId);
    if (stationIndex === -1) {
      return null;
    }
    this._data.stations = this._data.stations.slice(stationIndex, 1);
    this.save();
  },
  getWorkouts(stationId) {
    const station = this.getStationById(stationId);
    if (!station) {
      return null;
    }
    if (!station.workouts) {
      station.workouts = [];
    }
    return station.workouts;
  },
  getLatestWorkout(stationId) {
    let workouts = this.getWorkouts(stationId).filter(
      e => e.sets && e.sets.length
    );
    if (!workouts.length) {
      const station = this.getStationById(stationId);
      return {
        timestamp: 0,
        sets: [{ reps: station.reps, weight: station.weight }]
      };
    }
    workouts.sort((a, b) => b.timestamp - a.timestamp);
    return workouts[0];
  },
  provideWorkout(stationId, timestamp) {
    const station = this.getStationById(stationId);
    if (!station.workouts) {
      station.workouts = [];
    }
    let workout = station.workouts.find(e => e.timestamp === timestamp);
    if (!workout) {
      workout = {
        timestamp,
        sets: []
      };
      station.workouts.push(workout);
    }
    return workout;
  }
};

// simple storage

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
